import React, { Component } from 'react';

export class Home extends Component {
  displayName = Home.name

  render() {
    return (
      <div>
        <h1>API Backend Recepción</h1>
        <p>Bienvenido al API Backend Recepción</p>        
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Home.js